import { ArrowDownward as ArrowDownwardIcon } from '@mui/icons-material';

const ArrowDownward = (): JSX.Element => <ArrowDownwardIcon fontSize="inherit" />;

export default ArrowDownward;
